export default function TokenDescription(props: {description: string}) {
  return <span>
    I see <i>{props.description}</i>
  </span>
}